import React, { createContext, useContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const savedToken = localStorage.getItem('authToken');
    console.log('Token salvo no localStorage:', savedToken);

    if (savedToken) {
      try {
        const decodedUser = jwtDecode(savedToken);
        setToken(savedToken);
        setUser(decodedUser);
        setIsAuthenticated(true);
        console.log('Usuário autenticado:', decodedUser);
      } catch (error) {
        console.error('Erro ao decodificar o token do localStorage:', error);
        logout(); // Desloga se o token for inválido
      }
    }
  }, []);

  const login = (token) => {
    if (!token || typeof token !== 'string') {
      console.error('Token inválido recebido:', token);
      return;
    }
  
    try {
      const decodedUser = jwtDecode(token);
      localStorage.setItem('authToken', token);
      setToken(token);
      setUser(decodedUser);
      setIsAuthenticated(true);
      console.log('Login bem-sucedido. Usuário:', decodedUser);
    } catch (error) {
      console.error('Erro ao decodificar o token:', error);
      logout();
    }
  };
  

  const logout = () => {
    console.log('Logout iniciado');
    localStorage.removeItem('authToken');
    setToken(null);
    setUser(null);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
